export default __webpack_public_path__ + "static/media/Group -5@2x.b278add6.png";